export default "__VITE_ASSET__BSyuC0C3__"